import { render, staticRenderFns } from "./ConfigScheduleAddSystemNotifications.vue?vue&type=template&id=8ada2fe2&scoped=true&"
import script from "./ConfigScheduleAddSystemNotifications.vue?vue&type=script&lang=js&"
export * from "./ConfigScheduleAddSystemNotifications.vue?vue&type=script&lang=js&"
import style0 from "./ConfigScheduleAddSystemNotifications.vue?vue&type=style&index=0&id=8ada2fe2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ada2fe2",
  null
  
)

export default component.exports